import Rails from '@rails/ujs'
import { confirm } from 'lib/rails-bootbox'

Rails.confirm = confirm

Rails.start()
